<template>
  <div>
    <overlay
      v-if="!user"
    />
    <div
      v-else
      class="text-center"
    >
      <div class="my-3">
        <span
          class="text-h4 text-sm-h3 font-weight-bold vertical-align-middle"
        >
          {{ user.nickname }}
        </span>
        <profile-picture
          :user="user"
          width="80px"
        />
      </div>
    </div>
    <v-tabs
      v-model="tab"
      :show-arrows="$vuetify.display.xs"
      background-color="transparent"
      color="secondary"
      class="tabs"
    >
      <v-tab>{{ $t('manager_profile.gallery') }}</v-tab>
    </v-tabs>
      <v-window
        v-model="tab"
      >
        <v-window-item
          class="mt-6"
        >
          <filter-menu
            @toggleLastScores="toggleLastScores($event)"
          />
          <cards-list
            :user-slug="userSlug"
            :is-clickable="false"
            :show-last-scores="showLastScores"
          />
        </v-window-item>
      </v-window>
  </div>
</template>

<script>
import ProfilePicture from '@/components/User/ProfilePicture.vue';
import Overlay from '@/components/Overlay.vue';
import FilterMenu from '@/components/Card/Filter/FilterMenu.vue';
import CardsList from '@/components/Card/CardsList.vue';
import UserService from '@/services/user.service';
import Filter from '@/models/Card/Filter/filter';
import { useUserStore } from '@/store/user.module';
import { useCardFilterStore } from '@/store/cardFilter.module';

export default {
  name: 'ManagerProfile',
  components: {
    ProfilePicture,
    Overlay,
    FilterMenu,
    CardsList,
  },
  setup() {
    const cardFilterStore = useCardFilterStore();

    return { cardFilterStore };
  },
  data() {
    const filter = new Filter({
      property: { isPlayingGw: false },
    });

    return {
      user: null,
      isLoading: true,
      tab: this.defaultTab(),
      showLastScores: false,
      filter,
    };
  },
  computed: {
    currentUser() {
      const userStore = useUserStore();
      return userStore.currentUser;
    },
    userSlug() {
      return this.user?.slug;
    },
  },
  watch: {
    $route() {
      this.getUserBySlug();
    },
  },
  mounted() {
    this.getUserBySlug();
    this.cardFilterStore.reset();
  },
  methods: {
    getUserBySlug() {
      const { userSlug } = this.$route.params;
      this.isLoading = true;
      UserService.getUserBySlug(userSlug)
        .then((response) => {
          this.user = response.user;
          this.isLoading = false;
        })
        .catch(() => {
          this.$router.push('/mega-league');
        });
    },
    toggleLastScores(showLastScores) {
      this.showLastScores = showLastScores;
    },
    defaultTab() {
      switch (this.$route.query.tab) {
        case 'gallery': return 1;
        default: return 0;
      }
    },
  },
};
</script>

<style scoped>

.tabs {
  max-width: 800px;
  min-height: 35px;
  background-color: transparent;
  position: relative;
  margin: 20px auto !important;
}
</style>
